import React, { useEffect, useRef, useState } from 'react';

import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import User from '../../models/User';
import useBlocRef from '../../utils/useBlocRef.hook';
import EditFields from '../common/EditFields';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => ({
  checkbox: {
    textAlign: 'left',
    width: '100%',
  },
  label: {
    fontWeight: 'bold',
  },
  submitContainer: {
    paddingTop: theme.spacing(4),
  },
}));

const inviteFields = [
  { label: 'Creator Name', name: 'name', placeholder: 'Creator Name', required: true, type: 'text' },
  { label: 'Telephone', name: 'phoneNumber', placeholder: '+27828501512', required: true, type: 'phone' },
  { label: 'Creator Email Address', name: 'email', placeholder: 'email@address.com', required: true, type: 'text' },
];

export default ({ onInviteCreator, defaultData = new User(), validationErrors = null, resetData, onSetExternalError, isSubmitting$ }) => {
  const classes = useStyles();
  const editFieldRef = useRef();
  const blocRef = useBlocRef('appBloc');

  const [workspace, setWorkspace] = useState({});
  const [isTrainee, setIsTrainee] = useState(false);

  useEffect(() => {
    const workspaceSub = blocRef.current.userWorkspace$.subscribe(setWorkspace);

    return () => {
      workspaceSub.unsubscribe();
    };
  }, []);

  const onInviteClick = async () => {
    const validData = await editFieldRef.current.getValidData();

    if (validData) {
      validData.isTrainee = isTrainee;

      onInviteCreator(validData);
    }
  };

  const handleTraineeChange = (event) => {
    setIsTrainee(event.target.checked);
  };

  return (
    <>
      <Typography variant="h5" align="left" className="secondary-header">
        Invite Creator
      </Typography>

      <EditFields
        fields={inviteFields}
        data={defaultData}
        labelPosition="top"
        labelClass={classes.label}
        validate={User.validateCreate}
        useAutoFocus={false}
        ref={editFieldRef}
        validationErrors={validationErrors}
        resetData={resetData}
        onSetExternalError={onSetExternalError}
      />

      {workspace.standAloneApp ? (
        <div className={classes.checkbox}>
          <FormControlLabel
            classes={{ root: 'mediphany-formcontrol-root' }}
            control={<Checkbox checked={isTrainee} onChange={handleTraineeChange} classes={{ root: 'mediphany-checkbox-root' }} color="primary" name="trainee" size="small" />}
            label={<Typography variant="body1">Trainee</Typography>}
          />
        </div>
      ) : null}

      <Typography variant="subtitle1" align="left" style={{ marginTop: '32px' }}>
        Note that an invitation link will be sent to the creator email address once submitted.
      </Typography>

      <Grid container className={classes.submitContainer}>
        <Grid item xs={12} sm={6}>
          <LoadingButton variant="contained" color="primary" fullWidth onClick={onInviteClick} loading$={isSubmitting$}>
            Invite Creator
          </LoadingButton>
        </Grid>
      </Grid>
    </>
  );
};
